import appStore from './appStore'

const store = {
  appStore
}
export default store


// WEBPACK FOOTER //
// ./src/store/index.js